<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Orders</h2>
    </div>

    <!--Order List Table Start-->
    <div class="orders-body">
      <a :href="`/catering-order-details/${order.id}`" v-for="order in displayList" :key="order.id">
      <div class="order-item" v-if="order.full_name">
        <div class="order-item-left">
          <div><span>#{{ order.id }}</span><br>{{ order.full_name }}</div>
        </div>
        <div class="order-item-right">
<!--          <div v-if="!isCatering(order)" class="order-status" :class="order.status === 1 ? 'new' : ''"><span>{{ order.status === 5 ? 'Completed' : order.status_name }}</span></div>
            <div v-else class="order-status new"><span>Catering Order</span></div>-->
          <button type="button" class="order-item-detail-button">View Details</button>
        </div>
      </div>
    </a>
    </div>
    <!--Order List Table End-->
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      pageCount: 0,
      itemCount: 20,
      sort_by_date: false,
      // Data Sidebar
      searched: []
    }
  },
  computed: {
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.ceil(array.length / this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      return page_array
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length
    },
    orders () {
      return this.$store.state.api.cateringOrders
    },
    orderList () {
      let orders = JSON.parse(JSON.stringify(this.$store.state.api.cateringOrders))
      orders = orders.filter(order => {
        return order
      })
      return orders.reverse()
    },

    displayList () {
      let array = JSON.parse(JSON.stringify(this.displayListSource))
      if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.order_date) - new Date(a.order_date)
        })
      }
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.searched.length > 0 ? this.searched : this.orderList
    },
    order_by_date () {
      return this.$store.state.api.order_by_date
    }
  },
  watch: {
    sort_by_date () {
      this.$store.commit('api/SET_ORDER_BY', this.sort_by_date)
    }
  },
  methods: {
    pageUp () {
      if (this.pageCount !== this.displayListSource.length) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    getOrderList () {
      const payload = {
        page: 1,
        limit: 20
      }

      this.$vs.loading()

      this.$store.dispatch('api/getCateringOrderList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    handleData () {
      this.getOrderList()
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
    this.handleData()
    this.sort_by_date = this.order_by_date
  }
}
</script>

<style lang="scss">
.orders-body {
  display:flex;
  flex-wrap: wrap;
  gap:20px;
  width: 100%;
  a {
    width:100%;
  }
}
  .order-item {
    display:flex;
    width:100%;
    justify-content: space-between;
    align-items: center;
    border-radius:3px;
    box-shadow:0px 0px 5px 2px rgba(0,0,0,0.1);
    padding:20px;
    transition:all .2s ease;
    &:hover, &:active, &:focus {
      background-color:#f9f9f9;
      box-shadow:0px 0px 5px 1px rgba(0,0,0,0.2);
    }
  }
  .order-item-detail-button{
    border:none;
    border-radius: 3px;
    color:#fff;
    background-color:#0070eb;
    padding:5px 10px;
  }
  .order-item-left{
    div:first-child{
      span{
        font-weight: bold;
      }
    }
    div:nth-child(2){
      font-weight: bold;
      font-style:italic;
    }
  }
  .order-item-right{
  .order-status {
      width:100%;
      border-radius: 3px;
      border:1px solid #ccc;
      text-align: center;
      margin-bottom:15px;
    }
  }
  .order-search{
    padding:20px;
    border-radius:3px;
    box-shadow:0px 0px 5px 2px rgba(0,0,0,0.1);
    margin-top:20px;
    margin-bottom:20px;
  }
  .order-search-form{
    display:flex;
    flex-wrap: wrap;
    gap:10px;
    width:100%;
    div{
      width:100%;
    }
    input[type="search"]{
      width:100%;
      border:1px solid #ccc;
      border-radius: 3px;
      padding:5px 10px;
      background-color:#f5f5f5;
    }
    button{
      width:100%;
      border:none;
      padding:5px 0px;
      background-color:#13aa37;
      color:#fff;
      border-radius: 3px;
    }
  }

</style>
